export default {
  deleteTitle: 'Country',
  overviewTitle: 'Countries',
  overviewRouterUrl: 'countries',
  getFilterName (context) { return 'countries' },
  overviewApiUrl: '/countries/',
  detailTitle: 'Country Detail',
  detailRouterUrl: 'country',
  detailApiUrl: '/countries/',
  quickFilterName: 'Name',
  quickFilterField: 'name',
  sortOrder: [
    {
      field: 'name',
      sortField: 'name',
      direction: 'asc'
    }
  ],
  fields:
  [
    {title: 'Code', name: 'cntry_code', sortField: 'cntry_code', link: '#/country/{id}'},
    {title: 'Name', name: 'cntry_name', sortField: 'cntry_name', link: '#/country/{id}'},
    {name: '__slot:actions', title: '', titleClass: 'text-center', dataClass: 'text-center'}
  ]
}



// WEBPACK FOOTER //
// ./src/views/Country/FieldDefs.js